import { render } from "./ToDo.vue?vue&type=template&id=675997b9&scoped=true"
import script from "./ToDo.vue?vue&type=script&lang=js"
export * from "./ToDo.vue?vue&type=script&lang=js"

import "./ToDo.vue?vue&type=style&index=0&id=675997b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675997b9"]])

export default __exports__